import React from "react";
import { SurveyTxt } from "../../SurveyTxt";
import { Card } from "../../designSystem/Card";
import { MessageCard } from "../../designSystem/Message";
import { Button } from "../../designSystem/button/Button";
import { ButtonRow } from "../../designSystem/button/ButtonRow";
import { H2 } from "../../designSystem/typography/Heading";
import { SurveyAnswerOkStatus, LanguageCode } from "../../amorg-common";
import { Flex } from "../../designSystem/compositeComponents/FlexHelpers";


type SurveyIntroductionViewProps = {
    txt:SurveyTxt,
    selectedLanguage:LanguageCode,
    answerStatus:SurveyAnswerOkStatus,
    onClickStart: () => void 
}
export function SurveyIntroductionView(props:SurveyIntroductionViewProps): JSX.Element {

    function getIntroText():string
    {
        if(props.selectedLanguage === props.answerStatus.defaultLanguage)
            return props.answerStatus.survey.intro.text;
        else
            return props.answerStatus.survey.intro.translations.find(t => t.languageCode === props.selectedLanguage)?.text || '';
    }

    return (
        <Flex flexDirection="column" gap={24}>
            <H2>{props.txt.introduction_header}</H2>
            <MessageCard variant="success" textAlign="left">
                {getIntroText()}
            </MessageCard>
            <ButtonRow marginTop={20}>
                <Button variant="filled" onClick={() => props.onClickStart()} text={props.txt.introduction_buttonStartText} />
            </ButtonRow>
        </Flex>
    );
}